/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { noop } from "~/tools";
import { FiltersProp } from "../types";
import { EstateDateRangeFilter } from "./EstateDateRangeFilter";
import { EstateFilterHeader } from "./EstateFilterHeader";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
};

export function UnallocatedEstateFilter({ filters, updateFilters }: Props) {
  const { assignmentUpdatedFrom = "", assignmentUpdatedTo = "" } = filters;

  return (
    <>
      <EstateFilterHeader onSetSearch={noop} />
      <EstateDateRangeFilter
        description="Define the dates of estate records` environment change from allocated to unallocated."
        dateFrom={assignmentUpdatedFrom}
        dateTo={assignmentUpdatedTo}
        onDateFromChange={(value) =>
          updateFilters({
            assignmentUpdatedFrom: value,
          })
        }
        onDateToChange={(value) =>
          updateFilters({
            assignmentUpdatedTo: value,
          })
        }
      />
    </>
  );
}
